import { Directive, ElementRef, HostListener, inject } from "@angular/core";

@Directive({ selector: "[stagesFocusError]" })
export class FocusErrorDirective {
	private elem = inject(ElementRef);

	@HostListener("submit") onSubmit(): void {
		const currentElem: HTMLTextAreaElement = this.elem.nativeElement;
		const firstInvalid = currentElem.querySelector("input.ng-invalid, textarea.ng-invalid, select.ng-invalid");
		if (firstInvalid) {
			(firstInvalid as HTMLElement).focus();
		}
	}
}
